import { useEffect } from 'react';

export function useEditorHotkeys({
  setActiveTool,
  onDelete,
  onUndo,
  onRedo,
  onGroup,
  onUngroup,
  setShowGrid,
  setShowCrosshair,
  setSnapToGuides,
}) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      const activeElement = document.activeElement;
      const isInputActive =
        activeElement &&
        (activeElement.tagName === 'INPUT' ||
          activeElement.tagName === 'TEXTAREA' ||
          activeElement.isContentEditable);

      if (isInputActive) return;

      const isCtrlOrCmd = e.ctrlKey || e.metaKey;

      if (isCtrlOrCmd && e.key.toLowerCase() === 'z') {
        e.preventDefault();
        if (e.shiftKey) {
          onRedo?.();
        } else {
          onUndo?.();
        }
        return;
      }

      if (isCtrlOrCmd && e.key.toLowerCase() === 'g') {
        e.preventDefault();
        if (e.shiftKey) {
          onUngroup?.();
        } else {
          onGroup?.();
        }
        return;
      }

      if (e.key === 'Delete' || e.key === 'Backspace') {
        e.preventDefault();
        onDelete?.();
        return;
      }

      if (e.key.toLowerCase() === 'g' && !isCtrlOrCmd) {
        e.preventDefault();
        setShowGrid?.(prev => !prev);
        return;
      }
      if (e.key.toLowerCase() === 'c' && !isCtrlOrCmd) {
        e.preventDefault();
        setShowCrosshair?.(prev => !prev);
        return;
      }
      if (e.key.toLowerCase() === 's' && !isCtrlOrCmd) {
        e.preventDefault();
        setSnapToGuides?.(prev => !prev);
        return;
      }

      if (isCtrlOrCmd || (e.altKey && e.key !== 'Alt')) return;

      switch (e.key.toLowerCase()) {
        case 'v':
          e.preventDefault();
          setActiveTool('select');
          break;
        case 'r':
          e.preventDefault();
          setActiveTool('rect');
          break;
        case 'c':
          e.preventDefault();
          setActiveTool('circle');
          break;
        case 'p':
          e.preventDefault();
          setActiveTool('pen');
          break;
        case 't':
          e.preventDefault();
          setActiveTool('text');
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [setActiveTool, onDelete, onUndo, onRedo, onGroup, onUngroup, setShowGrid, setShowCrosshair, setSnapToGuides]);
}